import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Sidebar from './Sidebar';
import Header from './Header';

const pageTitles = {
  '/dashboard':        'Dashboard',
  '/inward':           'Inward Receipt',
  '/inward/new':       'New Inward Receipt',
  '/grn':              'GRN (Goods Receipt Note)',
  '/grn/new':          'New GRN',
  '/quarantine':       'Quality Assurance',
  '/rack':             'Rack Storage',
  '/dispatch':         'Outward Dispatch',
  '/dispatch/new':     'New Dispatch Order',
  '/dispatch-hold':    'Dispatch Hold',
  '/direct-delivery':  'Direct Delivery',
  '/direct-delivery/new': 'New Direct Delivery',
  '/users':            'User Management',
  '/warehouses':       'Warehouses',
  '/clients':          'Clients',
  '/reports':          'Reports & Analytics',
  '/products':         'Products (SKU Master)',
  '/suppliers':        'Suppliers',
  '/portal':           'My Inventory',
  '/portal/inbound':   'Inbound Shipments',
  '/portal/dispatches':'My Dispatches',
  '/admin/roles':      'Roles & Permissions',
  '/admin/modules':    'Modules & Features',
};

const getTitle = (pathname) => {
  if (pageTitles[pathname]) return pageTitles[pathname];
  const base = '/' + pathname.split('/')[1];
  return pageTitles[base] ?? 'Ziplogyx IMS';
};

const AppShell = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const title = getTitle(location.pathname);

  return (
    <div className="flex h-screen bg-zip-bg overflow-hidden">
      {/* Desktop sidebar */}
      <div className="hidden lg:flex flex-shrink-0 border-r border-zip-border">
        <Sidebar />
      </div>

      {/* Mobile drawer overlay */}
      <AnimatePresence>
        {sidebarOpen && (
          <>
            <motion.div
              key="backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="fixed inset-0 z-40 bg-black/70 backdrop-blur-sm lg:hidden"
              onClick={() => setSidebarOpen(false)}
            />
            <motion.div
              key="drawer"
              initial={{ x: -240 }}
              animate={{ x: 0 }}
              exit={{ x: -240 }}
              transition={{ type: 'spring', stiffness: 400, damping: 35 }}
              className="fixed inset-y-0 left-0 z-50 border-r border-zip-border shadow-2xl lg:hidden"
            >
              <Sidebar onClose={() => setSidebarOpen(false)} />
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* Main area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title={title} onMenuClick={() => setSidebarOpen(true)} />

        <main className="flex-1 overflow-auto">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, x: 8 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -8 }}
              transition={{ duration: 0.18, ease: 'easeOut' }}
              className="p-5 lg:p-7 min-h-full"
            >
              {children}
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </div>
  );
};

export default AppShell;
